import AddAdaptationModal from "./AddAdaptationModal";

export default AddAdaptationModal;
